export default __webpack_public_path__ + "static/media/1938.a6cd305d.png";